import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderStandardPictureElement } from "../../utils";

export default {
    title: "Components/Teaser Image",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-teaser-image",
    args: {
        alignCtaTop: "false",
        greenBorder: "false",
        href: "null",
        imageAutoHeight: "false",
        imageRatio: "4:3",
        inlineTextSlot: "false",
        noShadow: "false",
        target: "null",
        textCtaRow: "false",
        textWrapperColumn: "false",
        showTags: "false",
        headline: "Teaser image headline",
    },
    argTypes: {
        showTags: {
            control: "boolean",
        },
        alignCtaTop: {
            control: "boolean",
        },
        greenBorder: {
            control: "boolean",
        },
        href: {
            control: "string",
        },
        imageAutoHeight: {
            control: "boolean",
        },
        imageRatio: {
            control: '"17:8" | "4:3" | "8:7"',
        },
        inlineTextSlot: {
            control: "boolean",
        },
        noShadow: {
            control: "boolean",
        },
        target: {
            control: "string",
        },
        textCtaRow: {
            control: "boolean",
        },
        textWrapperColumn: {
            control: "boolean",
        },
    },
};

const Template = ({
    alignCtaTop,
    greenBorder,
    href,
    imageAutoHeight,
    imageRatio,
    inlineTextSlot,
    noShadow,
    target,
    textCtaRow,
    textWrapperColumn,
    headline,
}) => html`
    <ux-iws-teaser-image
        align-cta-top="${alignCtaTop}"
        green-border="${greenBorder}"
        href="${href}"
        image-auto-height="${imageAutoHeight}"
        image-ratio="${imageRatio}"
        inline-text-slot="${inlineTextSlot}"
        no-shadow="${noShadow}"
        target="${target}"
        text-cta-row="${textCtaRow}"
        text-wrapper-column="${textWrapperColumn}"
    >
        <div slot="image">
            ${renderStandardPictureElement({
                width: 1200,
                height: 600,
            })}
        </div>
        <h5
            class="ux-text-headline ux-text-headline--medium ux-u-mb-xxxs ux-u-mt-zero"
            slot="headline"
        >
            ${headline}
        </h5>
        <ux-text-lines-limit text-lines="4" slot="text">
            <div class="ux-text-normal ux-text-normal--light-gray">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
                takimata sanctus est. Lorem ipsum dolor sit amet, consetetur
                sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
                labore et dolore magna aliquyam erat,.
            </div>
        </ux-text-lines-limit>
    </ux-iws-teaser-image>
`;

export const Default = Template.bind({});

const TemplateSlots = ({
    alignCtaTop,
    greenBorder,
    href,
    imageAutoHeight,
    imageRatio,
    inlineTextSlot,
    noShadow,
    target,
    textCtaRow,
    textWrapperColumn,
    headline,
}) => html`
    <ux-iws-teaser-image
        align-cta-top="${alignCtaTop}"
        green-border="${greenBorder}"
        href="${href}"
        image-auto-height="${imageAutoHeight}"
        image-ratio="${imageRatio}"
        inline-text-slot="${inlineTextSlot}"
        no-shadow="${noShadow}"
        target="${target}"
        text-cta-row="${textCtaRow}"
        text-wrapper-column="${textWrapperColumn}"
    >
        <div slot="image">
            ${renderStandardPictureElement({
                width: 1200,
                height: 600,
            })}
        </div>
        <span class="ux-tag" slot="tags">Tag 1</span>
        <strong
            class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
            slot="label"
        >
            teaser box label
        </strong>
        <h5
            class="ux-text-headline ux-text-headline--medium ux-u-mb-xxxs ux-u-mt-zero "
            slot="headline"
        >
            ${headline}
        </h5>
        <ux-text-lines-limit text-lines="4" slot="text">
            <div class="ux-text-normal ux-text-normal--light-gray">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
                takimata sanctus est. Lorem ipsum dolor sit amet, consetetur
                sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
                labore et dolore magna aliquyam erat,.
            </div>
        </ux-text-lines-limit>
        <div slot="cta">
            <a
                class="ux-button ux-button--icon-only"
                href="#"
                aria-label="Lorem Ipsum"
                role="button"
            >
                <ux-icon name="chevron-right" weight="medium"></ux-icon>
            </a>
        </div>
    </ux-iws-teaser-image>
`;

export const Slots = TemplateSlots.bind({});
